<template>
  <div>
    <StepperHeaderComponent />
    <v-card class="mx-auto" elevation="0">
      <form @submit.prevent="getInvoices">
        <v-card-text class="text-center">
      <v-row>
        <v-col lg="8" class="mx-auto">
        <v-alert
        border="top"
        color="#15314e"
         :value="alert"
      dark
      icon="mdi-alert"
      transition="scroll-y-transition"
      dismissible
      style="font-size:20px; color:#ff8400"
      >
      
        ¡Parece que te encuentras al día! <strong>No</strong> encontramos facturas pendiente asociadas a tu documento
      </v-alert>

        </v-col>
      </v-row>
          <p class="text-h4 text--primary">Pago de facturas</p> 
          <div>Ingresa tu número de documento para obtener las facturas</div>
          <br /><br /><br /><br />
          <v-row>
            <v-col lg="4" class="mx-auto">
              <v-card flat>
                <v-text-field
                  :autofocus="true"
                  label="Número de documento"
                  hide-details="auto"
                  v-model="holderCode"
                  prepend-icon="mdi-text-box-search-outline"
                  stlye="width:300px"
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
          <br /><br />
          <br /><br /><br />
          <v-row>
            <v-col lg="4" class="mx-auto">
              <v-btn
                class="mx-auto"
                color="#ff8400"
                style="color: white"
                large
                x-large
                block
                :loading="loading"
                :disabled="loading"
                type="submit"
              >
                Consultar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </form>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import StepperHeaderComponent from "../../components/layout/StepperHeaderComponent.vue";
export default {
  name: "SearchInvoice",
  components: {
    StepperHeaderComponent,
  },
  async mounted() {
   
    // console.log("Query", this.$route.query.paymentId);
    // let paymentId = this.$route.query.paymentId ? this.$route.query.paymentId : '';
    // if(paymentId != ''){
    //   console.clear();
    //   console.log("Traigo un paymentId por el query y es: " + paymentId);
    //   const transaction = await this.$store.dispatch("moduleAch/getTransaction", paymentId);
    //   const stateTransaction = this.$store.getters["moduleAch/getStatus"];
    //   console.clear()
    //   console.log("Transaction", this.$store.getters["moduleAch/getTransaction"]);
    //   if(stateTransaction) {
    //     if(stateTransaction == 'OK'){
    //       let stateToSend = 'APPROVED'
    //       console.log("La transacción tiene como estado OK, entonces debo enviar a que se paguen las facturas en Nodum");
    //       await this.$store.dispatch("moduleAch/getInvoices", paymentId);
    //       await this.$store.dispatch("moduleAch/sendToPay", stateToSend);
          
    //       // window.location ="/buscar"
    //     }else if(stateTransaction == 'NOT_AUTHORIZED'){
    //       let stateToSend = 'DECLINED'

    //       await this.$store.dispatch("moduleAch/getInvoices", paymentId);
    //       await this.$store.dispatch("moduleAch/sendToPay", stateToSend);

    //     }else{
    //       console.log("La transacción tiene un estado distinto a OK (approved), entonces se manda ese estado a las facturas en Nodum");
    //       await this.$store.dispatch("moduleAch/getInvoices", paymentId);
    //       await this.$store.dispatch("moduleAch/sendToPay", stateTransaction);
          
    //       // window.location ="/buscar"
    //     }      
    //   }
    // }
  },

  data() {
    return {
      alert: false,
      loader: null,
      loading: false,
    };
  },
  computed: {
    holderCode: {
      get() {
        return this.$store.state.holderCode;
      },
      set(value) {
        this.$store.commit("updateHolderCode", value);
      },
    },
  },
  methods: {
    async getInvoices() {
      this.alert = false
      
      this.loader = "loading";
      const l = this.loader;
      this[l] = !this[l];
      await this.$store.dispatch("getInvoices", this.holderCode);
      this.loader = null;
      this[l] = !this[l];

      if (this.$store.getters.invoices.length > 0) {
        
        localStorage.setItem('holderCode', this.holderCode)
        this.$store.commit('moduleInvoice/setHolderCode', this.holderCode)
        
        this.$router.push("listar");
      }else{
        this.alert = true
         setTimeout(() => {
            this.alert = false
          }, 10000)
          
      }
    },
  },
};
</script>